import React from 'react';

export const WhatIsDirectDebit = ({ isOpen, onRequestClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 w-screen h-screen flex items-start justify-center bg-black/50 font-duplet text-xs">
      <div className="bg-white w-full md:w-2/3 overflow-y-auto max-h-[90vh] mt-8 flex flex-col rounded-lg shadow-lg">
        {/* Header */}
        <div className="flex justify-between items-center border-b px-6 py-4">
          <h2 className="text-lg font-semibold">What is Direct Debit?</h2>
          <button
            onClick={onRequestClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="px-6 py-4 space-y-4">
          <p>
            <strong>Direct debit</strong> is an automatic payment that gives us
            permission to collect funds directly from your bank account on an
            agreed-upon basis, such as daily, weekly or monthly. It allows for
            fixed or variable amounts to be taken on a scheduled date.
          </p>

          <div>
            <h3 className="font-semibold">How it works</h3>
            <p className="mt-2">
              By submitting a Direct Debit Request on the SmallSmall website or
              mobile application, you authorize SmallSmall to debit your
              nominated account or card through our authorized payment gateway,
              Paystack, in accordance with your selected payment plan.
            </p>
            <p className="mt-2">
              Debits will occur on the agreed dates. If a debit date falls on a
              non-business day, the debit may occur on the following business
              day. Direct debit is a payment method and does not of itself
              constitute an acceptance of any arrangement to clear arrears
              unless specifically approved by SmallSmall.
            </p>
          </div>

          <div>
            <h3 className="font-semibold">Use of Paystack as Payment Gateway</h3>
            <p className="mt-2">
              All direct debit transactions on SmallSmall are securely processed
              by Paystack Payments Limited (“Paystack”). Paystack may collect
              and store your payment details (including bank account or card
              information) for the purpose of processing recurring payments.
              SmallSmall does not store or retain your sensitive financial
              information. You agree to comply with Paystack’s terms of service
              and privacy policy, which govern the handling of your payment
              information.
            </p>
          </div>
        </div>

        <div className="border-t px-6 py-4 flex justify-end">
          <button
            onClick={onRequestClose}
            className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2 rounded-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

